import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function ServicePage() {
  return (
    <div className="service-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="hero-bg-image" style={{ backgroundImage: 'url(/images/hero-service.png)' }}></div>
        <div className="page-header-overlay"></div>
        <Container>
          <h1 className="page-title">Service</h1>
          <p className="page-subtitle">
            成長を設計する、4つの領域
          </p>
        </Container>
      </section>

      {/* 01 グロースデザイン */}
      <section className="service-detail" id="growth-design">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="service-detail-header">
                <div className="service-detail-number">01</div>
                <h2 className="service-detail-title">グロースデザイン</h2>
                <p className="service-detail-subtitle">Growth Design</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="service-detail-image-wrapper">
                <img src="/images/service-media.jpg" alt="グロースデザイン" className="service-detail-image" />
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={10} className="mx-auto">
              <div className="service-detail-content">
                <div className="problem-box">
                  <h4 className="problem-title">こんな課題はありませんか？</h4>
                  <ul className="problem-list">
                    <li>広告費をかけても利益が残らない</li>
                    <li>リピート率が低く、顧客が定着しない</li>
                    <li>売上は伸びているが、どこがボトルネックかわからない</li>
                    <li>KPIが曖昧で、施策の優先順位が決められない</li>
                  </ul>
                </div>
                <p>
                  ファネル分析×コホート分析を軸に、商品やサービスのポテンシャルが正しく届く成長構造を設計します。
                  「どこで離脱しているのか」「どの顧客が利益を生んでいるのか」を可視化し、
                  感覚ではなくデータに基づいた成長戦略を描きます。
                </p>
                <ul className="service-features">
                  <li>ファネル全体の構造分析と課題特定</li>
                  <li>コホート分析による顧客行動の可視化</li>
                  <li>KGI/KPI設計と施策の優先順位づけ</li>
                  <li>LTV向上施策の立案・実行支援</li>
                  <li>成果報酬型の座組み設計</li>
                </ul>
                <p>
                  手法の前に、構造を。施策を積み上げるだけでは成長は続きません。
                  事業全体を俯瞰し、利益が残る仕組みそのものを設計することが、
                  持続的な成長の出発点だと考えています。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 02 メディア＆コンテンツ */}
      <section className="service-detail service-detail-alt" id="media-content">
        <Container>
          <Row className="align-items-center flex-lg-row-reverse">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="service-detail-header text-lg-end">
                <div className="service-detail-number">02</div>
                <h2 className="service-detail-title">メディア＆コンテンツ</h2>
                <p className="service-detail-subtitle">Media & Content</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="service-detail-image-wrapper">
                <img src="/images/service-rpa.jpg" alt="メディア＆コンテンツ" className="service-detail-image" />
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={10} className="mx-auto">
              <div className="service-detail-content">
                <div className="problem-box">
                  <h4 className="problem-title">こんな課題はありませんか？</h4>
                  <ul className="problem-list">
                    <li>広告費をかけ続けないと集客が止まってしまう</li>
                    <li>記事を書いても上位表示されず、アクセスが伸びない</li>
                    <li>LPの改善ポイントがわからず、CVRが頭打ちになっている</li>
                    <li>コンテンツをつくっても、ブランドの世界観が伝わっていない</li>
                  </ul>
                </div>
                <p>
                  オウンドメディア構築、認知設計コンテンツ、LP制作など、
                  「選ばれる理由」をつくる情報設計を行います。
                  検索面での資産を積み上げながら、商品の価値が正しく伝わるコンテンツを設計します。
                </p>
                <ul className="service-features">
                  <li>オウンドメディアの戦略立案・構築・運用</li>
                  <li>コンテンツの企画・制作（SEO記事、ブランドコンテンツ）</li>
                  <li>LP（ランディングページ）の制作・改善</li>
                  <li>認知設計コンテンツの企画・ディレクション</li>
                  <li>ドメイン評価の強化施策（官公庁プロジェクトへの参加支援、高品質な被リンク獲得）</li>
                  <li>アクセス解析とPDCAの運用</li>
                </ul>
                <p>
                  広告費は使い続けなければ集客が止まりますが、
                  メディアとコンテンツは積み上げるほどに資産となります。
                  「届けたい人に、届くべき情報が届く」状態をつくることが、
                  長期的な成長基盤の構築につながります。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 03 テクノロジー */}
      <section className="service-detail" id="technology">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="service-detail-header">
                <div className="service-detail-number">03</div>
                <h2 className="service-detail-title">テクノロジー</h2>
                <p className="service-detail-subtitle">Technology</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="service-detail-image-wrapper">
                <img src="/images/service-ai.jpg" alt="テクノロジー" className="service-detail-image" />
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={10} className="mx-auto">
              <div className="service-detail-content">
                <div className="problem-box">
                  <h4 className="problem-title">こんな課題はありませんか？</h4>
                  <ul className="problem-list">
                    <li>単純作業に時間を取られ、本来やるべき業務に集中できない</li>
                    <li>AIを導入したいが、自社のどの業務に適用すべきかわからない</li>
                    <li>SNSを始めたいが、運用に割くリソースがない</li>
                    <li>RPA導入のコストが高すぎて、費用対効果が合わない</li>
                  </ul>
                </div>
                <p>
                  RPA、AI活用、SNS自動化など、仕組みの力で成長を加速させるテクノロジーの実装を支援します。
                  人が判断すべきことに集中できる環境をつくり、事業全体の生産性を引き上げます。
                </p>

                <h3 className="service-sub-heading">RPA（業務自動化）</h3>
                <div className="compare-table-wrapper">
                  <h4 className="compare-title">PerfTechのRPA vs 従来のRPA</h4>
                  <div className="compare-table">
                    <div className="compare-header">
                      <div></div>
                      <div>従来のRPA</div>
                      <div className="compare-highlight">PerfTech RPA</div>
                    </div>
                    <div className="compare-row">
                      <div className="compare-label">正確性</div>
                      <div>AI依存で揺らぎあり</div>
                      <div className="compare-highlight">プログラム実行で正確無比</div>
                    </div>
                    <div className="compare-row">
                      <div className="compare-label">ランニングコスト</div>
                      <div>AI従量課金が継続発生</div>
                      <div className="compare-highlight">実行時の課金なし</div>
                    </div>
                    <div className="compare-row">
                      <div className="compare-label">柔軟性</div>
                      <div>SaaSの制約内</div>
                      <div className="compare-highlight">スクラッチで自由に対応</div>
                    </div>
                    <div className="compare-row">
                      <div className="compare-label">構築コスト</div>
                      <div>1タスク数十万〜100万円</div>
                      <div className="compare-highlight">大幅にコストダウン</div>
                    </div>
                    <div className="compare-row">
                      <div className="compare-label">マーケティング対応</div>
                      <div>業務の置き換えが中心</div>
                      <div className="compare-highlight">マーケロジックを組み込み可能</div>
                    </div>
                  </div>
                </div>
                <p>
                  AIを活用してプログラムを構築し、そのプログラムを定期実行する独自の方式を採用。
                  実行時にはAIは介在しないため、揺らぎのない正確な処理と低コスト構造を両立させています。
                </p>

                <h3 className="service-sub-heading">AI導入支援</h3>
                <ul className="service-features">
                  <li>業務フローの分析とAI活用ポイントの特定</li>
                  <li>AIツールの選定・導入サポート</li>
                  <li>運用体制の構築と定着支援</li>
                  <li>社内ナレッジのAI活用</li>
                </ul>

                <h3 className="service-sub-heading">SNS運用オートメーション</h3>
                <ul className="service-features">
                  <li>投稿の自動スケジューリング・実行</li>
                  <li>エンゲージメントデータの自動収集・分析</li>
                  <li>複数プラットフォームの一元管理</li>
                  <li>エゴサーチ対策としての良質な投稿の量産</li>
                </ul>

                <p>
                  テクノロジーは人を置き換えるものではなく、人の可能性を広げるものです。
                  自動化できることは仕組みに任せ、人間にしかできない判断と設計に集中できる環境をつくります。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 04 広告・集客最適化 */}
      <section className="service-detail service-detail-alt" id="acquisition">
        <Container>
          <Row className="align-items-center flex-lg-row-reverse">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="service-detail-header text-lg-end">
                <div className="service-detail-number">04</div>
                <h2 className="service-detail-title">広告・集客最適化</h2>
                <p className="service-detail-subtitle">Acquisition Optimization</p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="service-detail-image-wrapper">
                <img src="/images/service-sns.jpg" alt="広告・集客最適化" className="service-detail-image" />
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg={10} className="mx-auto">
              <div className="service-detail-content">
                <div className="problem-box">
                  <h4 className="problem-title">こんな課題はありませんか？</h4>
                  <ul className="problem-list">
                    <li>広告のCPAが高騰し、利益を圧迫している</li>
                    <li>効果測定ができておらず、何が効いているかわからない</li>
                    <li>SEOと広告の連携ができていない</li>
                    <li>A/Bテストを回したいが、設計や運用の知見がない</li>
                  </ul>
                </div>
                <p>
                  広告運用、SEO、A/Bテストなど、届ける手段の精度を高める実行支援を行います。
                  グロースデザインで描いた成長構造に基づき、
                  集客チャネルごとの最適化を実行します。
                </p>
                <ul className="service-features">
                  <li>リスティング広告・ディスプレイ広告の運用最適化</li>
                  <li>SEO戦略の立案・実行（YMYL領域を含む専門的な対策）</li>
                  <li>A/Bテストの設計・実行・分析</li>
                  <li>集客チャネルのポートフォリオ最適化</li>
                  <li>広告クリエイティブの改善サイクル構築</li>
                </ul>
                <p>
                  手法の最適化だけでは、成果は頭打ちになります。
                  グロースデザインで設計した全体構造の中で、
                  各チャネルの役割を明確にし、投資対効果を最大化していきます。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="section-cta">
        <Container>
          <h2>共に成長できるパートナーを、探しています。</h2>
          <p className="cta-sub">
            私たちは、すべてのご相談をお受けしているわけではありません。
            商品やサービスに真剣に向き合い、共に成長していける関係を大切にしています。
            まずは、お互いにとって最善かどうかを一緒に考えるところから始めませんか。
          </p>
          <Link to="/contact" className="btn-primary-custom">
            ご相談はこちら
          </Link>
        </Container>
      </section>
    </div>
  );
}

export default ServicePage;
